module.exports = __webpack_public_path__ + "img/C533.981d70ff.jpg";